<mat-toolbar class="!bg-secondary !sticky top-0 z-50 shadow-md">
   <div class="container mx-auto px-4 flex items-center justify-between w-full">
      <!-- Logo -->
      <div class="flex items-center gap-2 cursor-pointer" routerLink="/">
         <mat-icon class="text-3xl text-primary">local_bar</mat-icon>
         <span class="text-xl font-bold tracking-tight text-white">BarHub</span>
      </div>

      <!-- Desktop Navigation -->
      <nav class="hidden md:flex items-center gap-2" *ngIf="!isSmallScreen()">
         <a mat-button routerLink="/" routerLinkActive="!bg-white/10" [routerLinkActiveOptions]="{exact: true}"
            class="!text-white hover:!bg-white/20 transition-all duration-300">Home</a>
         <!-- These four routes existed but NOTHING linked to them: /bars,
              /customer/dashboard, /notifications and /ratings were reachable
              only by typing the address. -->
         <a mat-button routerLink="/bars" routerLinkActive="!bg-white/10"
            class="!text-white hover:!bg-white/20 transition-all duration-300">Bars</a>
         <a mat-button routerLink="/customer" routerLinkActive="!bg-white/10"
            class="!text-white hover:!bg-white/20 transition-all duration-300">Customer</a>
         <a mat-button routerLink="/service-provider" routerLinkActive="!bg-white/10"
            class="!text-white hover:!bg-white/20 transition-all duration-300">Provider</a>
         <a *ngIf="isAuthenticated()" mat-button routerLink="/customer/dashboard"
            routerLinkActive="!bg-white/10"
            class="!text-white hover:!bg-white/20 transition-all duration-300">My Visits</a>
         <a *ngIf="isAuthenticated()" mat-button routerLink="/ratings" routerLinkActive="!bg-white/10"
            class="!text-white hover:!bg-white/20 transition-all duration-300">Ratings</a>
         <a *ngIf="isAuthenticated()" mat-button routerLink="/notifications"
            routerLinkActive="!bg-white/10" aria-label="Notifications"
            class="!text-white hover:!bg-white/20 transition-all duration-300">Notifications
            <!-- The count was fetched and polled but never displayed. -->
            <span *ngIf="unreadNotifications > 0" data-test="header-unread-badge"
                  class="ml-1 inline-flex items-center justify-center rounded-full bg-red-600 text-white text-xs font-bold px-2"
                  style="min-width:20px;height:20px;line-height:20px">{{ unreadNotifications > 99 ? '99+' : unreadNotifications }}</span></a>
         <a *ngIf="!isAuthenticated()" mat-button (click)="startLogin()"
            class="!text-white hover:!bg-white/20 transition-all duration-300 cursor-pointer">Login</a>
      </nav>

      <!-- Mobile Menu Button -->
      <button mat-icon-button *ngIf="isSmallScreen()" (click)="toggleMobileMenu()" class="md:hidden !text-white">
         <mat-icon>{{ isMobileMenuOpen() ? 'close' : 'menu' }}</mat-icon>
      </button>
   </div>

   <!-- Mobile Navigation -->
   <nav
      class="absolute top-16 left-0 right-0 bg-secondary flex flex-col shadow-lg md:hidden w-5/6 ml-auto p-3 rounded-lg"
      *ngIf="isSmallScreen() && isMobileMenuOpen()">
      <a mat-button routerLink="/" routerLinkActive="!bg-white/10" (click)="closeMobileMenu()"
         [routerLinkActiveOptions]="{exact: true}"
         class="!text-white !justify-start px-6 py-3 hover:!bg-white/20 transition-all duration-300">Home</a>
      <a mat-button routerLink="/bars" routerLinkActive="!bg-white/10" (click)="closeMobileMenu()"
         class="!text-white !justify-start px-6 py-3 hover:!bg-white/20 transition-all duration-300">Bars</a>
      <a *ngIf="isAuthenticated()" mat-button routerLink="/customer/dashboard"
         routerLinkActive="!bg-white/10" (click)="closeMobileMenu()"
         class="!text-white !justify-start px-6 py-3 hover:!bg-white/20 transition-all duration-300">My Visits</a>
      <a *ngIf="isAuthenticated()" mat-button routerLink="/ratings"
         routerLinkActive="!bg-white/10" (click)="closeMobileMenu()"
         class="!text-white !justify-start px-6 py-3 hover:!bg-white/20 transition-all duration-300">Ratings</a>
      <a *ngIf="isAuthenticated()" mat-button routerLink="/notifications"
         routerLinkActive="!bg-white/10" (click)="closeMobileMenu()"
         class="!text-white !justify-start px-6 py-3 hover:!bg-white/20 transition-all duration-300">Notifications
            <span *ngIf="unreadNotifications > 0" data-test="header-unread-badge"
                  class="ml-1 inline-flex items-center justify-center rounded-full bg-red-600 text-white text-xs font-bold px-2"
                  style="min-width:20px;height:20px;line-height:20px">{{ unreadNotifications > 99 ? '99+' : unreadNotifications }}</span></a>
      <a mat-button routerLink="/customer" routerLinkActive="!bg-white/10" (click)="closeMobileMenu()"
         class="!text-white !justify-start px-6 py-3 hover:!bg-white/20 transition-all duration-300">Customer</a>
      <a mat-button routerLink="/service-provider" routerLinkActive="!bg-white/10" (click)="closeMobileMenu()"
         class="!text-white !justify-start px-6 py-3 hover:!bg-white/20 transition-all duration-300">Provider</a>
      <a *ngIf="!isAuthenticated()" mat-button (click)="closeMobileMenu(); startLogin()"
         class="!text-white !justify-start px-6 py-3 hover:!bg-white/20 transition-all duration-300 cursor-pointer">Login</a>
   </nav>
</mat-toolbar>